import { Component, input } from '@angular/core';
import { DateFormat } from '@lx/shared/i18n';
import { NgIf } from '@angular/common';
import { StudyPeriodPipe } from '@lx/quote-tool/lite/shared/ui/pipes';

@Component({
  standalone: true,
  selector: 'lx-dates',
  templateUrl: './dates.component.html',
  styleUrls: ['./dates.component.scss'],
  imports: [NgIf, StudyPeriodPipe],
})
export class DatesComponent {
  startDate = input<string>();
  endDate = input<string>();
  emptyMsg = input<string>();

  protected readonly dateFormat = DateFormat;
}
